export default __webpack_public_path__ + "ubisoft-playtest-icon-dots-black.webp";